/// <reference types="@angular/localize" />
import 'hammerjs';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import '@angular/localize/init';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import dayjs from 'dayjs';
import 'dayjs/plugin/timezone'
import 'dayjs/plugin/isoWeek';
import UTC from 'dayjs/plugin/utc';
import CustomDateFormat from 'dayjs/plugin/customParseFormat';
import Duration from 'dayjs/plugin/duration';
import IsSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import IsSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import weekday from 'dayjs/plugin/weekday'
import duration from 'dayjs/plugin/duration'

dayjs.extend(weekday)
dayjs.extend(localizedFormat)
dayjs.extend(CustomDateFormat);
dayjs.extend(UTC);
dayjs.extend(Duration);
dayjs.extend(IsSameOrBefore);
dayjs.extend(IsSameOrAfter);
dayjs.extend(duration);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).then(() => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw-master.js');
  }
}).catch(err => console.log(err));
